import { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const BookingDetailRedirect = () => {
  const { booking_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("user");
    const parsed = JSON.parse(userData);

    if (!parsed?.user_type) {
      // if no user or no user_type — redirect to login
      toast.error("Not logged in");
      navigate("/");
      return;
    }

    if (parsed.user_type === 1) {
      // user
      navigate(`/user-experience-detail/${booking_id}`);
    } else if (parsed.user_type === 2) {
      // host
      navigate(`/host-experience-detail/${booking_id}`);
    } else {
      // fallback
      toast.error("Not Authorised");
      navigate("/");
    }
  }, [booking_id, navigate]);

  return null; // No UI needed — it’s just redirect logic
};

export default BookingDetailRedirect;
